/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_EyebrowInputs */

const tr_landing_pricing_eyebrow = /** @type {(inputs: Landing_Pricing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fiyatlandırma`)
};

const en_landing_pricing_eyebrow = /** @type {(inputs: Landing_Pricing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pricing`)
};

const de_landing_pricing_eyebrow = /** @type {(inputs: Landing_Pricing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise`)
};

const ru_landing_pricing_eyebrow = /** @type {(inputs: Landing_Pricing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`тарифы`)
};

/**
* | output |
* | --- |
* | "pricing" |
*
* @param {Landing_Pricing_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_eyebrow = /** @type {((inputs?: Landing_Pricing_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_eyebrow(inputs)
	if (locale === "de") return de_landing_pricing_eyebrow(inputs)
	if (locale === "ru") return ru_landing_pricing_eyebrow(inputs)
	return tr_landing_pricing_eyebrow(inputs)
});